import { React2 } from "../assets";

export let react = [
    {
      videoId: "p6MbmwR1dtQ",
      time: "22:42",
      icon: React2,
      url: "react-hooks-usestate",
      heading: "React JS - React Tutorial (1) React Hooks useState",
      description: "Learn how to use the useState hook in React for managing state in functional components.",
  
    },
    {
      videoId: "40QyMB0R3x8",
      time: "47:38",
      icon: React2,
      url: "react-hooks-useeffect",
      heading: "React JS - React Tutorial (2) React Hooks useEffect",
      description: "Explore the useEffect hook in React for performing side effects in functional components.",
    
    },
    {
      videoId: "4sQPrJcrVSQ",
      time: "23:45",
      icon: React2,
      url: "react-array-aap-method",
      heading: "ReactJS - React Tutorial (3) Array Map Method",
      description: "Discover how to use the map method to iterate over arrays in React.",
     
    },
    {
      videoId: "3Z-QTKjhksE",
      time: "26:18",
      icon: React2,
      url: "react-component-&-methods",
      heading: "React JS Component & methods | React Tutorial (4)",
      description: "Learn about React components and various methods associated with them.",
     
    },
    {
      videoId: "-bnbVLl2hM8",
      time: "13:21",
      icon: React2,
      url: "react-conditional-rendering",
      heading: "React JS Conditional Rendering | React Tutorial (5)",
      description: "Master conditional rendering techniques in React for rendering components based on conditions.",
    
    },
    {
      videoId: "0ezV_kJ2Jgs",
      time: "17:14",
      icon: React2,
      url: "react-npm-packages",
      heading: "Benefit of React | Npm Packages | React Tutorial (6)",
      description: "Explore the benefits of React and npm packages in this React Tutorial",
      
    },
  ];
  
  